import type { UserToken } from "#/entity";

export const USER_TOKEN_STORAGE_KEY = "h5.user-token";

const hasTokenPair = (value: unknown): value is Required<UserToken> => {
	if (!value || typeof value !== "object") return false;
	const token = value as UserToken;
	return (
		typeof token.accessToken === "string" &&
		token.accessToken.trim().length > 0 &&
		typeof token.refreshToken === "string" &&
		token.refreshToken.trim().length > 0
	);
};

export const readPersistedUserToken = (): UserToken => {
	try {
		const value = JSON.parse(localStorage.getItem(USER_TOKEN_STORAGE_KEY) ?? "null");
		return hasTokenPair(value) ? value : {};
	} catch {
		return {};
	}
};

export const clearPersistedUserToken = (): void => {
	try {
		localStorage.removeItem(USER_TOKEN_STORAGE_KEY);
	} catch {
		// Storage can be unavailable in privacy-restricted browser contexts.
	}
};

export const writePersistedUserToken = (token: UserToken): void => {
	if (!hasTokenPair(token)) {
		clearPersistedUserToken();
		return;
	}

	try {
		localStorage.setItem(USER_TOKEN_STORAGE_KEY, JSON.stringify(token));
	} catch {
		// Storage can be unavailable in privacy-restricted browser contexts.
	}
};
